PJQ.collections.directcosts = PJQ.collections.directcosts ? PJQ.collections.directcosts : {};;
PJQ.models.directcosts = PJQ.models.directcosts ? PJQ.models.directcosts : {};
PJQ.views.directcosts = PJQ.views.directcosts ? PJQ.views.directcosts : {};

PJQ.modules.directcosts = {
    routes: [
        {
            route: 'projects/:projectId/directcosts',
            name: 'directcosts',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "directcosts");
            }
        },
        {
            route: 'projects/:projectId/directcosts/:directCostId',
            name: 'directcosts',
            callback: function (projectId, directCostId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "directcosts", {
                    directCostId: parseInt(directCostId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.directcosts.routes);
